import he from 'he';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { ControlGroup, ControlOption, Icon } from '..';

const associationProps = (association) => ({
  key: association.value,
  value: association.value,
  checked: association.selected,
  label: <span>{he.decode(association.label)}</span>
})

const AssociationFilter = ({
  onAssociationChange,
  toggleFilter,
  showFilter,
  associations
}) => (
    <div className='filter association-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox justify-between'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            Filter by association
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
          </h2>
        </Col>
      </Row>
      <Collapse id='filter' in={showFilter}>
        <form>
          <fieldset>
            <ControlGroup id='association' className='no-margin' control='checkbox' type='styled' label={null} colProps={{ xs: 12, sm: 4, md: 2 }} onChange={onAssociationChange}>
              {
                fp.flow(
                  fp.sortBy(association => association.label),
                  fp.map(association => <ControlOption className='no-margin' {...associationProps(association)} />)
                )(associations)
              }
            </ControlGroup>
          </fieldset>
        </form>
      </Collapse>
    </div>
  )

const getUpdatedAssociations = (associations, associationToToggle) => fp.flow(
  fp.map(
    (association) => ({
      ...association,
      selected: association.value === associationToToggle ? !association.selected : association.selected
    })
  )
)(associations)

export default compose(
  withStateHandlers(
    {
      showFilter: false
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      })
    }
  ),
  withStateHandlers(
    ({ associations }) => ({
      associations: fp.map(
        (association) => ({
          ...association,
          selected: false
        })
      )(associations)
    }),
    {
      setAssociations: () => (associations) => ({
        associations
      })
    }
  ),
  withHandlers({
    onAssociationChange: ({ onChange, setAssociations, associations }) => (e) => {
      const associationName = e.target.value
      const updatedAssociations = getUpdatedAssociations(associations, associationName)
      setAssociations(updatedAssociations)
      const selectedAssociations = fp.flow(
        fp.filter('selected'),
        fp.map('value')
      )(updatedAssociations)
      onChange(selectedAssociations)
    }
  })
)(AssociationFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/association-filter.js